(function() {
	'use strict';

	angular.module('smb-app')
		.directive('smbDocumentDetails', DocumentDetailsDirective)
		.controller('smbDocumentDetailsController', ['smbDocumentDetailsPanelDataStore', DocumentDetailsController]);

	var templateUrl = require('./documentDetails.template');
	function DocumentDetailsDirective() {
		return {
			restrict: 'E',
			controller: 'smbDocumentDetailsController',
			controllerAs: 'vm',
			templateUrl: templateUrl,
			bindToController: true,
			scope: {
				documentGroupId: '@',
				documentTypeId: '@',
				documentId: '@'
			}
		};
	}

	function DocumentDetailsController(smbDocumentDetailsPanelDataStore) {
		var vm = this;
		vm.detailsDS = smbDocumentDetailsPanelDataStore;
	}
}());


//////////////////
// WEBPACK FOOTER
// ./app/components/documentDetails/documentDetails.js
// module id = 80
// module chunks = 1